import React from "react"

// One headline KPI in the top strip: big value, optional small line under the
// value, and an optional delta footnote tinted by tone. Used 5-up on desktop.
export function Kpi({ label, value, sub, delta, deltaTone = "neutral", footnote }) {
  const tone =
    deltaTone === "up"
      ? "text-emerald-600 dark:text-emerald-400"
      : deltaTone === "down"
        ? "text-red-600 dark:text-red-400"
        : "text-gray-500 dark:text-gray-400"

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-5">
      <p className="text-sm font-medium text-gray-500 dark:text-gray-400">{label}</p>
      <p className="mt-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-gray-100">{value}</p>
      {sub && <p className="mt-0.5 text-xs text-gray-400 dark:text-gray-500">{sub}</p>}
      {delta && <p className={`mt-2 text-xs font-medium ${tone}`}>{delta}</p>}
      {footnote && <p className="mt-1 text-xs text-gray-400 dark:text-gray-500">{footnote}</p>}
    </div>
  )
}
